<div
  (mouseenter)="onHover(true)"
  (mouseleave)="onHover(false)"
  class="relative w-full h-full overflow-hidden transition-all duration-300 ease-in-out"
>
>
  <div
    class="h-full w-16 bg-primary-600/35 absolute left-0 top-0 z-20 rounded-r-[3rem] flex flex-col justify-between overflow-hidden"
  >
    <button appRipple (click)="previous()" class="w-16 h-16 text-white">
      <mat-icon>arrow_upward</mat-icon>
    </button>

    <div class="flex flex-col items-center gap-1">
      @for (slide of slides; track $index) {
      <button
        appRipple
        (click)="changeSlide($index)"
        [class]="$index == activeIndex ? 'bg-primary-500' : 'bg-white'"
        class="h-8 w-1 rounded-full transition-all duration-300 ease-in"
      ></button>
      }
    </div>

    <button appRipple (click)="next()" class="w-16 h-16 text-white">
      <mat-icon>arrow_downward</mat-icon>
    </button>
  </div>

  @for (slide of slides; track $index) {
  <img
    [src]="slide.src"
    (load)="onImageLoad(slide.src)"
    style="display: none"
    alt="loading"
  />
  } @for (slide of slides; track $index) { @if($index === activeIndex){
  <div
    *ngIf="loadedImages.get(slide.src)"
    [animate.enter]="direction() === 'down' ? 'animate-up' : 'animate-down'"
    [animate.leave]="direction() === 'down' ? 'animate-uper' : 'animate-downer'"
    class="absolute inset-0 w-full h-full flex justify-center"
  >
    <img
      [src]="slide.src"
      alt="slide"
      class="absolute w-full h-full object-cover"
    />


  </div>
  } }

      <!-- overlay -->
    <div
    class="absolute top-0 left-0 w-full h-full bg-[#2d6a80]/70 z-10 flex flex-col justify-center px-32">
      <div
        animate.enter="animate-up"
        animate.leave="animate-down"
      class="flex flex-col gap-2">
        <span class="text-white text-4xl font-bold mt-5 mb-2">
          eMikutano
        </span>
        <p class="text-gray-100 text-lg">
          Conduct a Meeting through the Internet, Anywhere and Anytime.
        </p>
      </div>
    </div>
</div>
